export class AjaxCheck {
    public static LogSend = () => {
        $(document).ajaxSend((event, xhr, options) => {
            let payload = null;
            if (options.data) {
                payload = options.data;
            }
            console.debug("ajaxSend", {
                headers: options.headers,
                trigger: event.currentTarget.activeElement,
                endpoint: options.url,
                payload: payload
            });
        })

    };

    public static LogComplete = () => {
        $(document).ajaxComplete((event, xhr, options) => {
            console.debug("ajaxComplete", {
                status: xhr.status,
                statusText: xhr.statusText,
                trigger: event.currentTarget.activeElement,
                endpoint: options.url,
                response: xhr.responseJSON,
            });
        })

    };

    public static LogSuccess = () => {
        $(document).ajaxSuccess((event, xhr, options) => {
            console.debug("ajaxSuccess", {
                status: xhr.status,
                statusText: xhr.statusText,
                trigger: event.currentTarget.activeElement,
                endpoint: options.url,
                response: xhr.responseJSON,
            });
        })

    };

    public static LogError = () => {
        $(document).ajaxError((event, xhr, options, exc) => {
            console.debug("ajaxError", {
                namespace: event.namespace,
                endpoint: options.url,
                status: xhr.status,
                statusText: xhr.statusText,
                trigger: event.currentTarget.activeElement,
                exception: exc
            });
        })

    };

}

export class Logger {

    constructor() {
               
        window.Logging = console;

        if (window.isIE11 || window.isEdge) {

            window.Logging.log = (message, args) => {
                return false;
            }

            window.Logging.info = (message, args) => {
                return false;
            }

            window.Logging.debug = (message, args) => {
                return false;
            }

            window.Logging.error = (message, args) => {
                return false;
            }

        } else {

            let logger = (type, data, args?) => {
                let timestamp = Date.now().toString();
                let tag = "[" + timestamp + ": " + type.toUpperCase() + "] ";
                let message = tag + data;

                if (args) {
                    let output = isNaN(args) ? typeof args === "string" ? args : { ...args } : args;
                    let logEntry = { message: message, output: output };
                    window.LogFile.push(logEntry);

                    // Output data to console if in debug mode
                    if (window.isDebug) {
                        window.Logging.log(message, output);
                    }

                    return;
                }

                if (window.isDebug) {
                    window.Logging.log(message);
                }

                window.LogFile.push({ message: message, output: null });

                return;
            }

            // Replace non-standard API console time()/timeEnd() with window.performance
            window.PerfLogs = [];
            console.time = (label: string) => {
                var t0 = performance.now();
                window.PerfLogs.push({ timer: label, time: t0 });
            }

            console.timeEnd = (label: string) => {
                var t1 = performance.now();
                var t0 = window.PerfLogs.find(t => t.timer === label).time;

                window.PerfLogs.push({ timer: label, time: t1 });
                let elapsed = "[AUDIT] '" + label + "' execution time: " + (t1 - t0) + "ms";

                console.info(elapsed);
                return;
            }

            if (window.isDebug) {

                // We intercept the relevant console.log methods but leave console.log() alone 
                // so we have a regular console to work with
                window.Logging.log = console.log;

                window.Logging.info = (message, args) => {
                    logger("info", message, args);
                }

                window.Logging.debug = (message, args) => {
                    logger("debug", message, args);
                }

                window.Logging.error = (message, args) => {
                    logger("error", message, args);
                }

                // Custom grouping handler
                let groups = window.InitLogs = [];
                let lastIndex = 0;
                window.Logging.group = (message) => {
                    groups.push(message);
                    lastIndex = groups.length - 1;
                    logger("info", '[INIT] ' + message);
                }

                window.Logging.groupEnd = () => {
                    let message = groups.splice(lastIndex, 1);
                    logger("info", '[COMPLETE] ' + message);
                }


                console = window.Logging;
            }
        }
                
    }    

    public static SendLogFileDump = (errMsg) => {
        const getCircularReplacer = () => {
            const seen = new WeakSet();
            return (key, value) => {
                if (value instanceof Window) {
                    return 'Window';
                }
                if (typeof value === "object" && value !== null) {
                    if (seen.has(value)) {
                        return;
                    }
                    seen.add(value);
                }                
                return value;
            };
        };

        let entry = JSON.stringify({
            error: errMsg,
            path: window.location.pathname,            
            trace: window.LogFile
        }, getCircularReplacer());

        let uAgent = (<any>window).uagent;

        $.ajax({
            type: 'post',
            url: '/UIErrorLogger',
            data: { level: 2, message: entry, uAgent: uAgent }
        }).done(() => {
            // Reset so we don't send redundant data
            window.LogFile = [];
        });

        return false; // So that the UI doesn't freeze
    }

    public static ListenGlobalErrors = () => {

        let tag = "[" + Date.now().toString() + ": ERROR] Unhandled exception";

        window.addEventListener("error", ((e) => {
            let trace = {
                message: e.message,
                source: e.srcElement,
                file: e.filename,
                col: e.colno,
                error: e.error
            }
            
            let logEntry = { message: tag, trace: trace };

            window.LogFile.push(logEntry);

            console.error(e.message, trace);
            console.log("Unhandled exception , logfile dump: ", window.LogFile);
            Logger.SendLogFileDump(e.message);
      
            return false; 
        }));

        // For IE backwards compatibility
        window.onerror = ((event, source, file, col, error) => {

            if (!window.navigator.pointerEnabled) {
                return; // Everyone else need not apply.
            }

            let trace = {
                event: event,
                source: source,
                file: file,
                col: col,
                error: error
            };

            let logEntry = { message: tag, trace: trace };

            window.LogFile.push(logEntry);
            console.error(event, trace);
            console.log("Unhandled exception , logfile dump: ", window.LogFile);
            Logger.SendLogFileDump(error.message);

            return false;
        });

        
    }

    public static ListenUnhandledRejection = () => {
        window.addEventListener('unhandledrejection', ((e) => {
            let trace = {
                type: e.type,
                source: e.srcElement,
                target: e.target,
                currentTarget: e.currentTarget,
                reason: e.reason
            }

            let tag = "[" + Date.now().toString() + ": ERROR] Unhandled rejection";
            let logEntry = { message: tag, trace: trace };

            window.LogFile.push(logEntry);
            console.error(JSON.stringify(e.reason), trace);
            console.log("Unhandled rejection , logfile dump: ", window.LogFile);
            Logger.SendLogFileDump(e.reason);

            return false;
        }));
    }

}

